import React, { Fragment, useEffect, useState } from 'react';

const DEFAULT_LOGO = 'https://imgur.com/kEzgWVd.png';

const UserPanel = () => {
    const full_name = localStorage.getItem('full_name');
    const school_name = localStorage.getItem('school_name');

    const [schoolLogo, setSchoolLogo] = useState(
        localStorage.getItem('school_logo_url') || DEFAULT_LOGO
    );

    useEffect(() => {
        const handleLogoUpdate = () => {
            setSchoolLogo(
                localStorage.getItem('school_logo_url') || DEFAULT_LOGO
            );
        };

        window.addEventListener('school-logo-updated', handleLogoUpdate);
        return () =>
            window.removeEventListener('school-logo-updated', handleLogoUpdate);
    }, []);

    return (
        <Fragment>
            <div className="sidebar-user text-center">
                <div style={{ marginBottom: '4px' }}>
                    <img
                        src={schoolLogo}
                        alt=" Logo"
                        style={{
                            maxWidth: '80px',
                            maxHeight: '80px',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }}
                    />
                </div>
                <h6
                    className="mt-3 f-14"
                    style={{
                        color: "#0B4C9C",
                        fontSize: 14,
                        fontWeight: 700,
                        lineHeight: 1.3,
                        letterSpacing: "-0.01em",
                        marginBottom: 4,
                        wordBreak: "break-word",
                    }}
                >
                    {full_name}
                </h6>
                <p>{school_name}</p>
            </div>
        </Fragment>
    );
};

export default UserPanel;
